<template>
	<a class="set_top_box">
		<p v-if="getText">{{ getText }}</p>
		<img :src="getImg" @click="setTop" />
	</a>
</template>
<script>
export default{
    props: {
        getText: {
            type: String,
            default: () => {
                return '';
            },
        },

        getImg: {
            type: String,
            default: () => {
                return require('../../static/images/back-top-icon.png');
            },
        },
    },

    methods: {
        setTop() {
            // 这里是重点
            this.$emit('fatherSetTop')
        },
    },
}
</script>

<style lang="less" scoped>
    .set_top_box {
    position: fixed;
    z-index: 999;
    right: 120px;
    bottom: 100px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    }

    .set_top_box > p {
    text-align: center;
    font-size: 13px;
    color: #999999;
    }

    .set_top_box > img {
    width: 5.208vw;
    height: 5.208vw;
    max-width: 100px;
    max-height: 100px;
    transition: all 0.5s;
    cursor: pointer;
    }

</style>